import  { useEffect, useState } from "react";
import { Grid, Container,
  Dialog,
  DialogContent,
  IconButton,
  Box, } from "@mui/material";
import "../../style/home/certificaciones/certificacion.css";
import AOS from 'aos';
import 'aos/dist/aos.css';
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
/* imagenes */
import logo from "../../img/home/acreditacion/nuevo.png";
import logo3 from "../../img/home/acreditacion/acreditaciones.jpg";
import descarga from "../../img/home/acreditacion/descarga.png";
import pdf from "../../img/pdf/Brochure_comercial_Axinntus_2026.pdf";
import pdf1 from "../../img/pdf/libro.pdf";
import pdf2 from "../../img/pdf/Brochure_comercial_KTV_2026.pdf";


export default function Certificacionhome() {
  const [openVideo, setOpenVideo] = useState(false);

const handleOpenVideo = () => setOpenVideo(true);
const handleCloseVideo = () => setOpenVideo(false);
  useEffect(() => {
    // Inicializa AOS con opciones de configuración si es necesario
    AOS.init({
      duration: 1000, // Duración de las animaciones en milisegundos
      once: true, // Solo realiza las animaciones una vez
    });
  }, []);

  return (
    <section>
      <Container
        maxWidth="md"
        sx={{ marginTop: '100px', marginBottom: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Grid container data-aos="zoom-in">
          <Grid item xs={12} sm={6}>
            <div className="certificaciones">
              <h2>Certificaciones</h2>
              <div className="iconos-certificaciones">
                <img src={logo} alt="Axinntus" />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className="certificaciones">
              <h2>Acreditaciones</h2>
              <div className="iconos-acreditacion">
                <img src={logo3} alt="Axinntus" />
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Grid container>
        <Grid item  xs={12} sm={12} md={4} className="brochure">
          <div className="brochure-info">
            <h2>Brochure</h2>
            <h3>Comercial</h3>
            <a href={pdf} download target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
              <button className="boton-descarga" variant="outlined">
                <div className="icono-descargar">
                  <img src={descarga} alt="servicios operación axinntus" />
                </div>
                Descargar
              </button>
            </a>
          </div>
        </Grid>
         <Grid item xs={12} sm={12} md={4} className="dron" sx={{background:'#34C7FF'}}>
          <div className="brochure-info">
            <h2>Brochure Comercial</h2>
            <h3>servicio limpieza de dron</h3>
            <a href={pdf2} download target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
              <button className="boton-descarga" variant="outlined">
                <div className="icono-descargar">
                  <img src={descarga} alt="servicios operación axinntus" />
                </div>
                Descargar
              </button>
            </a>
          </div>
        </Grid>
        <Grid item  xs={12} sm={12} md={4} className="libro" >
          <div className="brochure-info">
            <h2>Libro</h2>
            <h3>10 años</h3>
            <a href={pdf1} download target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>
              <button className="boton-descarga" variant="outlined">
                <div className="icono-descargar">
                  <img src={descarga} alt="servicios operación axinntus" />
                </div>
                Descargar
              </button>
            </a>
          </div>
        </Grid>
      </Grid>

      <Container
        maxWidth="xxl"
        sx={{
          width: "100%",
          height: "100%",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: "0px",
          paddingLeft: "0px",
          paddingRight: "0px",
          '@media (max-width: 600px)': {
            paddingLeft: "0px",
            paddingRight: "0px",
            '& .MuiContainer-root': {
              paddingLeft: "0px",
              paddingRight: "0px"
            }
          },
          '& .MuiContainer-root': {
            paddingLeft: "0px",
            paddingRight: "0px"
          }
        }}
      >
         <Box
  onClick={handleOpenVideo}
  sx={{
    width: "100%",
    height: "100%",
    cursor: "pointer",
    overflow: "hidden",
    borderRadius: 3,
    position: "relative",

    "& video": {
      transition: "transform .5s ease",
    },

    "& .videoOverlay": {
      opacity: 0,
      background: "rgba(0,0,0,0)",
      transition: "all .35s ease",
    },

    "& .playIcon": {
      transform: "scale(.7)",
      transition: "all .35s ease",
    },

    "&:hover video": {
      transform: "scale(1.03)",
    },

    "&:hover .videoOverlay": {
      opacity: 1,
      background: "rgba(0,0,0,.45)",
    },

    "&:hover .playIcon": {
      transform: "scale(1)",
    },
  }}
>
  <video
    autoPlay
    muted
    loop
    playsInline
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
    }}
  >
   <source
    src="https://www.axinntus.com/videos/video1.mp4"
    type="video/mp4"
  />
  </video>

  <Box
    className="videoOverlay"
    sx={{
      position: "absolute",
      inset: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <PlayCircleFilledIcon
      className="playIcon"
      sx={{
        fontSize: 95,
        color: "#fff",
        filter: "drop-shadow(0 10px 20px rgba(0,0,0,.45))",
      }}
    />
  </Box>
</Box> 
      </Container>
      <Dialog
  open={openVideo}
  onClose={handleCloseVideo}
  maxWidth="lg"
  fullWidth
  PaperProps={{
    sx: {
      backgroundColor: "#000",
      borderRadius: 3,
      overflow: "hidden",
    },
  }}
>
  <IconButton
    onClick={handleCloseVideo}
    sx={{
      position: "absolute",
      right: 10,
      top: 10,
      zIndex: 2,
      color: "#fff",
      backgroundColor: "rgba(0,0,0,.5)",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,.7)",
      },
    }}
  >
    <CloseIcon />
  </IconButton>

  <DialogContent sx={{ p: 0 }}>
    <video
      controls
      autoPlay
      style={{
        width: "100%",
        maxHeight: "80vh",
        display: "block",
        background: "#000",
      }}
    >
      <source
    src="https://www.axinntus.com/videos/video1.mp4"
    type="video/mp4"
  />
      Tu navegador no soporta el video.
    </video>
  </DialogContent>
</Dialog>
    </section>
  );
}